import {createAction, props} from '@ngrx/store';
import {IStates} from '../models/IStatesModel';


export enum StatesActions {
  RETRIEVE_STATES = '[IStates] RetrieveStates',
  STATES_RECEIVED = '[IStates] StatesReceived',
  ERROR_RETRIEVING_STATES = '[IStates] ErrorRetrievingStates'
}

export const retrieveStatesAction = createAction(
  StatesActions.RETRIEVE_STATES,
  props<{ year: number }>()
);

export const statesReceivedAction = createAction(
  StatesActions.STATES_RECEIVED,
  props<{ states: Array<IStates> }>()
);

export const retrieveStatesErrorAction = createAction(
  StatesActions.ERROR_RETRIEVING_STATES,
  props<{ error: any }>()
);
